import * as RefundSummary from './components/RefundSummary.css';
import * as CommonContent from './components/Services/CommonContent.css';
import * as Notice from './components/Notice/Notice.css';
export default {
    RefundSummary,
    CommonContent,
    Notice
};
